import { render, staticRenderFns } from "./myselfInfo.vue?vue&type=template&id=5c322a12&scoped=true"
import script from "./myselfInfo.vue?vue&type=script&lang=js"
export * from "./myselfInfo.vue?vue&type=script&lang=js"
import style0 from "./myselfInfo.vue?vue&type=style&index=0&id=5c322a12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c322a12",
  null
  
)

export default component.exports